{
  "PROFILE_SETTINGS": {
    "LINK": "Profile Settings",
    "TITLE": "Profile Settings",
    "BTN_TEXT": "Update Profile",
    "DELETE_AVATAR": "Delete Avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar has been deleted successfully",
    "AVATAR_DELETE_FAILED": "There is an error while deleting avatar, please try again",
    "UPDATE_SUCCESS": "Your profile has been updated successfully",
    "PASSWORD_UPDATE_SUCCESS": "Your password has been changed successfully",
    "AFTER_EMAIL_CHANGED": "Your profile has been updated successfully, please login again as your login credentials are changed",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Slika za e-poštni podpis",
        "HINT": "Uporablja se v e-poštnih podpisih. {'{{'}email_signature_picture{'}}'} se nadomesti z URL-jem te slike (in ne z oznako slike) — uporabite ga kot vir slike (atribut src oznake img) v svojem podpisu ali podpisu nabiralnika. Če ni nastavljena, se nič ne vstavi.",
        "DELETE_SUCCESS": "Slika za e-poštni podpis je bila uspešno izbrisana",
        "DELETE_FAILED": "Pri brisanju slike za e-poštni podpis je prišlo do napake, poskusite znova"
      },
      "AVATAR": "Profile Image",
      "ERROR": "Please fix form errors",
      "REMOVE_IMAGE": "Remove",
      "UPLOAD_IMAGE": "Upload image",
      "UPDATE_IMAGE": "Update image",
      "PROFILE_SECTION": {
        "TITLE": "Profile",
        "NOTE": "Your email address is your identity and is used to log in."
      },
      "SEND_MESSAGE": {
        "TITLE": "Hotkey to send messages",
        "NOTE": "You can select a hotkey (either Enter or Cmd/Ctrl+Enter) based on your preference of writing.",
        "UPDATE_SUCCESS": "Your settings have been updated successfully",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Send messages by pressing Enter key instead of clicking the send button."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Send messages by pressing Cmd/Ctrl + enter key instead of clicking the send button."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Prilagodite videz svoje nadzorne plošče.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Default",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Jezik nadzorne plošče",
          "NOTE": "Prepišite jezik računa za svojo nadzorno ploščo. Pustite prazno za uporabo privzete nastavitve računa.",
          "USE_ACCOUNT_DEFAULT": "Uporabi privzeto nastavitev računa",
          "API_SUCCESS": "Jezik nadzorne plošče je bil uspešno posodobljen"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Jezik sporočila",
          "NOTE": "Izberite, ali naj se prikažejo izvirna sporočila ali njihovi prevodi",
          "ORIGINAL": "Izvirno",
          "TRANSLATED": "Prevedeno"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Vedenje pri lepljenju",
          "NOTE": "Izberite, kako naj se prilepljena vsebina obdela pri sestavljanju sporočil",
          "UPDATE_SUCCESS": "Vaše nastavitve lepljenja so bile uspešno posodobljene",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Ohrani vse oblikovanje",
              "DESCRIPTION": "Pri lepljenju vsebine ohrani vse oblikovanje, vključno s tabelami, slogi in drugimi elementi HTML."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Samo besedilo s povezavami",
              "DESCRIPTION": "Pri lepljenju vsebine pretvori v navadno besedilo, a ohrani klikljive povezave."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Samo navadno besedilo",
              "DESCRIPTION": "Pri lepljenju vsebine odstrani vse oblikovanje in pretvori v navadno besedilo."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Višina polja za odgovor",
          "NOTE": "Nastavite najmanjšo višino polja za odgovor kot odstotek višine zaslona. Velja samo za e-poštne pogovore.",
          "UPDATE_SUCCESS": "Nastavitev višine polja za odgovor je bila uspešno posodobljena",
          "PERCENT_LABEL": "Višina (% višine zaslona)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Privzeto",
              "DESCRIPTION": "Polje za odgovor se začne majhno in raste, ko tipkate."
            },
            "CUSTOM": {
              "HEADING": "Po meri",
              "DESCRIPTION": "Polje za odgovor je vedno vsaj tako visoko kot izbrani odstotek višine zaslona."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Samodejni preklop na naslednji pogovor",
        "NOTE": "Po rešitvi trenutnega pogovora se samodejno preklopi na naslednji odprt pogovor",
        "UPDATE_SUCCESS": "Nastavitev samodejnega preklopa je bila uspešno posodobljena"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Personal message signature",
        "DESCRIPTION": "Ustvarite edinstven podpis sporočila, ki se bo prikazal na koncu vsakega poslanega e-poštnega sporočila. Vključite lahko tudi vgrajeno sliko.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Save message signature",
        "API_ERROR": "Couldn't save signature! Try again",
        "API_SUCCESS": "Signature saved successfully",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Message Signature",
        "ERROR": "Message Signature cannot be empty",
        "PLACEHOLDER": "Insert your personal message signature here."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Geslo",
        "NOTE": "Updating your password would reset your logins in multiple devices.",
        "BTN_TEXT": "Change password"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Access Token",
        "NOTE": "This token can be used if you are building an API based integration",
        "COPY": "Copy",
        "REGENERATE": "Ponovno ustvari",
        "REGENERATE_SUCCESS": "Žeton za dostop je bil uspešno ponovno ustvarjen. Posodobite vse integracije, ki uporabljajo stari žeton.",
        "REGENERATE_CONFIRM_TITLE": "Ponovno ustvarim žeton za dostop?",
        "REGENERATE_CONFIRM_MESSAGE": "S tem bo trenutni žeton postal neveljaven. Vse integracije, ki uporabljajo stari žeton, bodo prenehale delovati."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Razširitev Chrome",
        "NOTE": "Namestite našo razširitev Chrome za podrobna obvestila o dohodnih telefonskih klicih.",
        "INSTALL_BUTTON": "Namesti razširitev",
        "ALREADY_INSTALLED": "Razširitev je nameščena"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "None",
          "MINE": "Assigned",
          "ALL": "All",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "None",
          "ASSIGNED": "Assigned Conversations",
          "ALL_CONVERSATIONS": "All Conversations"
        },
        "DEFAULT_TONE": {
          "TITLE": "Alert tone:"
        },
        "CONDITIONS": {
          "TITLE": "Alert conditions:",
          "CONDITION_ONE": "Send audio alerts only if the browser window is not active",
          "CONDITION_TWO": "Send alerts every 10s until all the assigned conversations are read"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Preberite več"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Email Notifications",
        "NOTE": "Update your email notification preferences here",
        "CONVERSATION_ASSIGNMENT": "Send email notifications when a conversation is assigned to me",
        "CONVERSATION_CREATION": "Send email notifications when a new conversation is created",
        "CONVERSATION_MENTION": "Send email notifications when you are mentioned in a conversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in an assigned conversation",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "E-pošta",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "V pogovoru brez razpoložljivega agenta je ustvarjeno novo sporočilo",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Dovoli potisna obvestila med klicem",
        "TEST_PUSH": "Preizkusi",
        "TESTING": "Preizkušanje ...",
        "TEST_PUSH_DESCRIPTION": "Pošljite preizkusna obvestila, da preverite svojo nastavitev",
        "TEST_NOTIFICATION_ERROR": "Pošiljanje preizkusnega obvestila ni uspelo. Poskusite znova.",
        "TEST_LOCAL_TITLE": "Preizkusno obvestilo (lokalno)",
        "TEST_LOCAL_BODY": "To je lokalno obvestilo brskalnika. Če to vidite, obvestila brskalnika delujejo!"
      },
      "API": {
        "UPDATE_SUCCESS": "Your notification preferences are updated successfully",
        "UPDATE_ERROR": "There is an error while updating the preferences, please try again"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push Notifications",
        "NOTE": "Update your push notification preferences here",
        "CONVERSATION_ASSIGNMENT": "Send push notifications when a conversation is assigned to me",
        "CONVERSATION_CREATION": "Send push notifications when a new conversation is created",
        "CONVERSATION_MENTION": "Send push notifications when you are mentioned in a conversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in an assigned conversation",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "You have enabled push for this browser.",
        "REQUEST_PUSH": "Enable push notifications",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profile Image"
      },
      "NAME": {
        "LABEL": "Your full name",
        "ERROR": "Please enter a valid full name",
        "PLACEHOLDER": "Please enter your full name"
      },
      "DISPLAY_NAME": {
        "LABEL": "Display name",
        "ERROR": "Please enter a valid display name",
        "PLACEHOLDER": "Please enter a display name, this would be displayed in conversations"
      },
      "POSITION": {
        "LABEL": "Položaj",
        "ERROR": "Vnesite veljaven položaj",
        "PLACEHOLDER": "Vnesite svoj položaj"
      },
      "CUSTOM_LINE": {
        "LABEL": "Vrstica po meri",
        "ERROR": "Vnesite veljavno vrstico po meri",
        "PLACEHOLDER": "Vnesite svojo vrstico po meri"
      },
      "AVAILABILITY": {
        "LABEL": "Availability",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Busy",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Availability has been set successfully",
        "SET_AVAILABILITY_ERROR": "Couldn't set availability, please try again"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Oblika predogleda e-pošte v seznamu pogovorov",
        "NOTE": "Izberite, kaj je prikazano v seznamu pogovorov za pogovore iz e-poštnih nabiralnikov",
        "SUBJECT": "Zadeva",
        "SUBJECT_WITH_NOTE": "Zadeva in zadnje sporočilo, če gre za interno opombo",
        "UPDATE_SUCCESS": "Nastavitev predogleda e-pošte je bila uspešno posodobljena"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Onemogoči bližnjice na tipkovnici",
        "NOTE": "Izklopi vse bližnjice na tipkovnici v celotni aplikaciji",
        "UPDATE_SUCCESS": "Nastavitev bližnjic na tipkovnici je bila uspešno posodobljena"
      },
      "FOLDER_ORDER": {
        "TITLE": "Vrstni red map",
        "NOTE": "Prilagodite vrstni red, v katerem se mape (pogledi po meri) prikažejo v stranski vrstici. Za spremembo vrstnega reda jih povlecite in spustite.",
        "NO_FOLDERS": "Ni najdenih map po meri. Ustvarite mape za organizacijo svojih pogovorov."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Nastavitev stranske vrstice",
        "NOTE": "Prilagodite, kateri razdelki se prikažejo v stranski vrstici pogovorov.",
        "SAVE_BUTTON": "Shrani nastavitev",
        "UPDATE_SUCCESS": "Nastavitev stranske vrstice je bila uspešno posodobljena",
        "UPDATE_ERROR": "Pri posodabljanju nastavitve stranske vrstice je prišlo do napake, poskusite znova",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Vsi pogovori",
          "ALL_CONVERSATIONS_DESC": "Prikaži element menija Vsi pogovori v stranski vrstici",
          "INBOX": "Nabiralnik",
          "INBOX_DESC": "Prikaži glavni nabiralnik z neprebranimi obvestili",
          "CONVERSATION_GROUPS": "Omembe in brez odgovora",
          "CONVERSATION_GROUPS_DESC": "Prikaži skupini pogovorov Omembe in Brez odgovora",
          "FOLDERS": "Mape",
          "FOLDERS_DESC": "Prikaži poglede po meri (mape) za organizirane pogovore",
          "TEAMS": "Ekipe",
          "TEAMS_DESC": "Prikaži pogovore, filtrirane po dodelitvi ekipam",
          "CHANNELS": "Nabiralniki",
          "CHANNELS_DESC": "Prikaži pogovore, filtrirane po nabiralniku",
          "LABELS": "Oznake",
          "LABELS_DESC": "Prikaži pogovore, filtrirane po oznakah"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Nastavitve telefona",
        "NOTE": "Vnesite prijavne podatke za svoj sistem PBX.",
        "USERNAME": "Uporabniško ime",
        "PASSWORD": "Geslo",
        "SUBMIT": "Shrani",
        "USERNAME_INVALID": "Uporabniško ime lahko vsebuje samo črke, števke ter . _ - + — brez presledkov in brez e-poštnega naslova.",
        "API": {
          "USERNAME_INVALID": "Uporabniško ime ni veljavno uporabniško ime SIP. Uporabite samo črke, števke ter . _ - + — brez presledkov in brez e-poštnega naslova.",
          "USERNAME_TAKEN": "To uporabniško ime že uporablja drug agent v tem računu."
        }
      },
      "EMAIL": {
        "LABEL": "Your email address",
        "ERROR": "Please enter a valid email address",
        "PLACEHOLDER": "Please enter your email address, this would be displayed in conversations"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Current password",
        "ERROR": "Please enter the current password",
        "PLACEHOLDER": "Please enter the current password"
      },
      "PASSWORD": {
        "LABEL": "New password",
        "ERROR": "Please enter a password of length 6 or more",
        "PLACEHOLDER": "Please enter a new password"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Confirm new password",
        "ERROR": "Confirm password should match the password",
        "PLACEHOLDER": "Please re-enter your new password"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Change",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Prijavi napako",
    "SELECTOR_SUBTITLE": "Select an account from the following list",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Prijavi napako",
    "DESCRIPTION_LABEL": "Opis težave",
    "DESCRIPTION_PLACEHOLDER": "Opišite težavo, na katero ste naleteli ...",
    "SUBMIT": "Pošlji prijavo",
    "SUBMITTING": "Pošiljanje ...",
    "CANCEL": "Prekliči",
    "SUCCESS": "Prijava napake je bila uspešno poslana. Hvala!",
    "VALIDATION_ERROR": "Pred pošiljanjem opišite težavo"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "days trial remaining.",
    "TRAIL_BUTTON": "Buy Now",
    "DELETED_USER": "Deleted User",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Account Suspended",
      "MESSAGE": "Your account is suspended. Please reach out to the support team for more information."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copy",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "Copied to clipboard"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Show More",
      "SHOW_LESS": "Show Less"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Download",
      "UPLOADING": "Nalaganje...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Ta zgodba ni več na voljo.",
      "RECORDING_UNAVAILABLE": "Ta posnetek ni več na voljo.",
      "DELETE_RECORDING": {
        "BUTTON": "Izbriši posnetek klica",
        "TITLE": "Želite izbrisati posnetek klica?",
        "DESCRIPTION": "Vsi posnetki tega klica bodo trajno izbrisani iz telefonske centrale in jih ne bo mogoče obnoviti. Prepis in povzetek klica ostaneta.",
        "CONFIRM": "Izbriši",
        "SUCCESS": "Posnetek klica je izbrisan",
        "ERROR": "Posnetka klica ni bilo mogoče izbrisati. Poskusite znova."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "See on map"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Submit"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Verifying...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Add Inbox"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Currently viewing:",
    "SWITCH": "Switch",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Conversations",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "All Conversations",
    "MENTIONED_CONVERSATIONS": "Mentions",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "Unattended",
    "REPORTS": "Reports",
    "SETTINGS": "Settings",
    "CONTACTS": "Contacts",
    "DATA_ASSISTANT": "Podatkovni asistent",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Home",
    "AGENTS": "Agents",
    "AGENT_BOTS": "Boti",
    "AUDIT_LOGS": "Audit Logs",
    "WHATSAPP_TEMPLATES": "Predloge za WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Inboxes",
    "NOTIFICATIONS": "Notifications",
    "CANNED_RESPONSES": "Canned Responses",
    "INTEGRATIONS": "Integrations",
    "PROFILE_SETTINGS": "Profile Settings",
    "ACCOUNT_SETTINGS": "Account Settings",
    "APPLICATIONS": "Applications",
    "LABELS": "Labels",
    "CUSTOM_ATTRIBUTES": "Custom Attributes",
    "AUTOMATION": "Automation",
    "MACROS": "Macros",
    "TEAMS": "Teams",
    "BILLING": "Billing",
    "CUSTOM_VIEWS_FOLDER": "Folders",
    "CUSTOM_VIEWS_SEGMENTS": "Segments",
    "ALL_CONTACTS": "All Contacts",
    "TAGGED_WITH": "Tagged with",
    "NEW_LABEL": "New label",
    "NEW_TEAM": "New team",
    "NEW_INBOX": "New inbox",
    "REPORTS_CONVERSATION": "Conversations",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Campaigns",
    "ONGOING": "Ongoing",
    "ONE_OFF": "One off",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agents",
    "REPORTS_LABEL": "Labels",
    "REPORTS_INBOX": "Inbox",
    "REPORTS_TEAM": "Team",
    "REPORTS_PHONE": "Telefon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Pregled",
    "WALLBOARD_QUEUES": "Čakalne vrste",
    "DATA_ASSISTANT_CHAT": "Klepet",
    "DATA_ASSISTANT_REPORTS": "Poročila",
    "NO_WAITING_CALLERS": "ni klicateljev v čakanju",
    "WAITING_CALLERS": "{count} klicateljev čaka",
    "SET_AVAILABILITY_TITLE": "Set yourself as",
    "SET_YOUR_AVAILABILITY": "Set your availability",
    "AVAILABILITY_IMPERSONATING": "Zaklenjeno, dokler ste prijavljeni kot ta uporabnik",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Nov pogovor",
    "DRAFT": "Osnutek",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Overview",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Help Center",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categories",
      "LOCALES": "Locales",
      "SETTINGS": "Settings",
      "DICTIONARY": "Slovar"
    },
    "CHANNELS": "Channels",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Mark offline automatically",
      "INFO_TEXT": "Let the system automatically mark you offline when you aren't using the app or dashboard.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Read docs"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Blokirane domene in kontakti",
    "DESCRIPTION": "Seznam blokiranih e-poštnih domen za ta račun.",
    "NO_BLOCKED_DOMAINS": "Ni najdenih blokiranih domen.",
    "BLOCKED_CONTACTS_BTN": "Blokirani kontakti"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Billing",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Current Plan",
      "PLAN_NOTE": "You are currently subscribed to the **{plan}** plan with **{quantity}** licenses",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Manage your subscription",
      "DESCRIPTION": "View your previous invoices, edit your billing details, or cancel your subscription.",
      "BUTTON_TXT": "Go to the billing portal"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Need help?",
      "DESCRIPTION": "Do you face any issues in billing? We are here to help.",
      "BUTTON_TXT": "Klepetajte z nami"
    },
    "NO_BILLING_USER": "Your billing account is being configured. Please refresh the page and try again."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Ojoj! Nismo našli nobenega računa. Za nadaljevanje ustvarite nov račun.",
    "NEW_ACCOUNT": "New Account",
    "SELECTOR_SUBTITLE": "Create a new account",
    "API": {
      "SUCCESS_MESSAGE": "Account created successfully",
      "EXIST_MESSAGE": "Account already exists",
      "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Company Name",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Submit",
      "CANCEL": "Prekliči"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "View all shortcuts",
    "TITLE": {
      "OPEN_CONVERSATION": "Open conversation",
      "RESOLVE_AND_NEXT": "Resolve and move to next",
      "NAVIGATE_DROPDOWN": "Navigate dropdown items",
      "RESOLVE_CONVERSATION": "Resolve Conversation",
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "ADD_ATTACHMENT": "Add Attachment",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "TOGGLE_SIDEBAR": "Toggle Sidebar",
      "GO_TO_REPORTS_SIDEBAR": "Go to Reports sidebar",
      "MOVE_TO_NEXT_TAB": "Move to next tab in conversation list",
      "GO_TO_SETTINGS": "Go to Settings",
      "SWITCH_TO_PRIVATE_NOTE": "Switch to Private Note",
      "SWITCH_TO_REPLY": "Switch to Reply",
      "TOGGLE_SNOOZE_DROPDOWN": "Toggle snooze dropdown",
      "AI_ASSIST_MENU": "Pomoč UI",
      "AI_ASSIST_GRAMMAR": "Popravi slovnico",
      "AI_ASSIST_UNIFY_LANG": "Poenoti jezik sporočila"
    }
  }
}
